import { inject, Injectable } from '@angular/core';
import { API_MAP } from 'app/core/helpers/api.map';
import { Result } from 'app/core/models/result';
import { BaseDataService } from 'app/core/services/base-data.service';
import { JobSettingsProperties } from 'app/shared/components/job/models/job.model';
import { DataService } from 'app/shared/services/data.service';
import { Observable, tap } from 'rxjs';
import { ExtendedContentPage } from '../models/content-pages.model';

@Injectable()
export class ContentPagesService extends BaseDataService<any> {
  override controller = API_MAP.contentPages;
  readonly #dataService = inject(DataService);

  override get(controller?: string): Observable<Result<ExtendedContentPage>> {
    return super.get(controller ?? this.controller).pipe(
      tap((d: Result<ExtendedContentPage>) => {
        this.content.set(d.content);
        this.components.set(d.components);
      })
    );
  }

  getJobById(id: string): Observable<Result<JobSettingsProperties>> {
    return this.#dataService.get<Result<JobSettingsProperties>>(API_MAP.jobs(id)).pipe(
      tap((d) => {
        this.content.set(d.content);
        this.components.set(d.components);
      })
    );
  }
}
